import type Geometry from 'ol/geom/Geometry';
import type { AppStore } from '../core/store';
import { liveEffectiveFor } from '../domain/liveEffective';
import { createSubareaPreview, type SubareaParent, type SubareaPreview } from '../domain/operationalSubareas';
import type { DrawingController, PartialDrawingTool } from './DrawingController';

export class PartialAreaController {
  constructor(
    private readonly store: AppStore,
    private readonly drawing: DrawingController,
    private readonly preview: (result: SubareaPreview) => void,
    private readonly status: (text: string) => void,
  ) {}

  begin(tool: PartialDrawingTool): void {
    const state = this.store.getState();
    if (!state.model) { this.store.update({ error: 'Carga primero un Maestro CASUR.' }); return; }
    const candidates = new Map<string, SubareaParent>();
    for (const entry of state.selectionSet.entries) {
      if (entry.source === 'master' && (entry.kind === 'suerte' || entry.kind === 'tablon')) {
        candidates.set(`${entry.kind}:${entry.id}`, { level: entry.kind, id: entry.id });
      }
    }
    if (!candidates.size && state.selection && (state.selection.kind === 'suerte' || state.selection.kind === 'tablon')) candidates.set(`${state.selection.kind}:${state.selection.id}`, { level: state.selection.kind, id: state.selection.id });
    if (candidates.size !== 1) {
      this.store.update({ error: candidates.size ? 'Selecciona una sola Suerte o un solo Tablón como padre del área parcial.' : 'Selecciona una Suerte o Tablón lógico antes de crear un área parcial.' });
      return;
    }
    const parent = [...candidates.values()][0]!;
    this.store.update({ activeTool: 'navigate', error: null });
    const model = state.model;
    this.drawing.capturePolygon(tool, (geometry: Geometry) => {
      try {
        const result = createSubareaPreview(this.store.getState().model!, parent, geometry);
        this.preview(result);
      } catch (error) {
        this.store.update({ error: error instanceof Error ? error.message : 'No fue posible intersectar el dibujo con el padre.' });
        this.status('Área parcial descartada');
      }
    }, { live: { title: 'Área parcial', effective: liveEffectiveFor(model, parent) } });
  }
}
